import { render, staticRenderFns } from "./GroupPanel.vue?vue&type=template&id=6ab6d576&scoped=true&"
import script from "./GroupPanel.vue?vue&type=script&lang=js&"
export * from "./GroupPanel.vue?vue&type=script&lang=js&"
import style0 from "./GroupPanel.vue?vue&type=style&index=0&id=6ab6d576&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab6d576",
  null
  
)

export default component.exports